import { AnalyticsEventSessionDuration } from 'lib/constants/AnalyticsEventType'
import { trackEvent } from 'lib/tracking/analytics-service'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

const SessionDurationTracking = () => {
    const SESSION_TRACKING_INTERVAL = 10000

    const router = useRouter()

    useEffect(() => {
        let sessionDuration = 0

        const interval = setInterval(() => {
            sessionDuration += SESSION_TRACKING_INTERVAL / 1000
            trackEvent(AnalyticsEventSessionDuration, {
                value: router.asPath,
                valueId: sessionDuration,
            })
        }, SESSION_TRACKING_INTERVAL)

        return () => {
            clearInterval(interval)
        }
    }, [router.asPath])

    return <></>
}

export default SessionDurationTracking
